import React, { useContext, useEffect, useState } from "react";
import { Get_Api } from "../ApiUrls";
import { CategoryContext } from "./CategoryProvider";
import { useNavigate } from "react-router-dom";

const MainSlider = ({ Name, setName, Location, setLocation }) => {
    const navigate = useNavigate();
    const { setSelectedCategory, selectedCategory, allCategories } = useContext(CategoryContext);
    const [slides, setSlides] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const tagline = "Enhancing User Satisfaction";
    const heading = "Explore Prime Real Estate Opportunities With Confidence Today!";

    const GetAllBanners = async () => {
        try {
            const response = await Get_Api(`api/admin/GetAllBanner`);
            setSlides(response?.data || []);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        GetAllBanners();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
        }, 5000);

        return () => clearInterval(interval);
    }, [slides]);


    const [IsUploading, setIsUploading] = useState(false);

    const [All_Locations, setAll_Locations] = useState([]);
    const Get_All_Locations = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api('api/admin/GetAllNewLocation');
            setAll_Locations(response.data);
            setIsUploading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        Get_All_Locations();
    }, []);

    const navigateto = (data) => {
        navigate(`/${data}`)
    }

    return (
        <div className="slider-container">
            {slides?.map((slide, index) => (
                <div
                    key={index}
                    className={`slide ${index === currentSlide ? "active" : ""}`}
                    style={{ backgroundImage: `url(${slide?.Image})` }}
                >
                    {index === currentSlide && (
                        <div className="slide-content">
                            <span className="tagline">{tagline}</span>
                            <h1 className="heading">{heading}</h1>
                            <button className="btn">View Details</button>
                        </div>
                    )}
                </div>
            ))}

            {/* Dots for navigation */}
            <div className="dots-container">
                {slides.map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${index === currentSlide ? "active" : ""}`}
                        onClick={() => setCurrentSlide(index)}
                    />
                ))}
            </div>

            <div className="search-container">
                <select>
                    <option value='' hidden>Select Property Type*</option>
                    {allCategories?.map((category, index) => (
                        <option key={index} value={category?._id}>
                            {category?.Name}
                        </option>
                    ))}
                </select>
                <select
                    value={Location}
                    onChange={(e) => { setLocation(e.target.value) }}
                >
                    <option value='' hidden>Select Location*</option>
                    {All_Locations?.map((location, index) => (
                        <option key={index} value={location?._id}>
                            {location?.Location}
                        </option>
                    ))}
                </select>
                <select>
                    <option value='' >Min Budget *</option>
                    <option>5 lac</option>
                    <option>10 lac</option>
                    <option>20 lac</option>
                    <option>30 lac</option>
                    <option>40 lac</option>
                    <option>50 lac</option>
                    <option>60 lac</option>
                    <option>70 lac</option>
                    <option>80 lac</option>
                    <option>90 lac</option>
                    <option>1 cr</option>
                    <option>1.2 cr</option>
                    <option>1.4 cr</option>
                    <option>1.6 cr</option>
                    <option>1.8 cr</option>
                    <option>2 cr</option>
                    <option>3 cr</option>
                    <option>4 cr</option>
                    <option>5 cr</option>
                    <option>6 cr</option>
                    <option>7 cr</option>
                    <option>8 cr</option>
                    <option>9 cr</option>
                    <option>10 cr</option>
                    <option>20 cr</option>
                    <option>30 cr</option>
                    <option>40 cr</option>
                    <option>50 cr</option>
                    <option>100 cr</option>
                </select>
                <select>
                    <option value='' >Max Budget *</option>
                    <option>5 lac</option>
                    <option>10 lac</option>
                    <option>20 lac</option>
                    <option>30 lac</option>
                    <option>40 lac</option>
                    <option>50 lac</option>
                    <option>60 lac</option>
                    <option>70 lac</option>
                    <option>80 lac</option>
                    <option>90 lac</option>
                    <option>1 cr</option>
                    <option>1.2 cr</option>
                    <option>1.4 cr</option>
                    <option>1.6 cr</option>
                    <option>1.8 cr</option>
                    <option>2 cr</option>
                    <option>3 cr</option>
                    <option>4 cr</option>
                    <option>5 cr</option>
                    <option>6 cr</option>
                    <option>7 cr</option>
                    <option>8 cr</option>
                    <option>9 cr</option>
                    <option>10 cr</option>
                    <option>20 cr</option>
                    <option>30 cr</option>
                    <option>40 cr</option>
                    <option>50 cr</option>
                    <option>100 cr</option>
                </select>
                <button className="search-btn" onClick={() => { navigateto('Properties') }}>Search</button>
            </div>
        </div>
    );
};

export default MainSlider;
